import { Injectable } from '@angular/core'
import { Subject } from 'rxjs/Subject'
import * as $ from 'jquery'

@Injectable()
export class ModalService {

    constructor() {
    }

    // Observable string sources
    private emitChangeSource = new Subject<any>()
    private emitScrollId = new Subject<any>()
    private emitChangeSourceParent = new Subject<any>()
    // Observable string streams
    changeEmitted$ = this.emitChangeSource.asObservable()
    scrollEmitted$ = this.emitScrollId.asObservable()
    changeEmittedSource$ = this.emitChangeSourceParent.asObservable()

    // Service message commands
    emitChange(change: any) {
        this.emitChangeSource.next(change)
    }

    scrollTo(elementId: any) {
        this.emitScrollId.next(elementId)
    }

    emitChangeParent(change: any) {
        this.emitChangeSourceParent.next(change)
    }

    fadingImage(callback, fadeOutSelector = '.fadeoutimage', fadeInSelector = '.fadeinimage') {
        const $fadeinImages = $(fadeInSelector)

        if (window['fadeTimeOut']) {
            clearTimeout(window['fadeTimeOut'])
            window['fadeTimeOut'] = null
        }

        window['fadeTimeOut'] = setTimeout(() => {
            $(fadeOutSelector).css({
                'opacity': 1,
                'transition': 'none',
            })
            $fadeinImages.css({
                'opacity': 0,
            })
            setTimeout(() => {

                const $fadeoutImages = $(fadeOutSelector)

                if (typeof callback == 'function') callback()

                $fadeoutImages.css('transition', 'opacity 0.5s linear 0.05s')
                $fadeoutImages.animate({
                    'opacity': 0,
                }, 500)
                $fadeinImages.animate({
                    'opacity': 1,
                }, 700)

                window['fadeTimeOut'] = null
            }, 5)
        }, 1000)
    }

}



// WEBPACK FOOTER //
// ./src/app/services/modal.service.ts